// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"142":"1461c7c3","340":"d81a45cd","343":"e12d9ec5"}[chunkId] + ".css";
};